<template>
  <el-dialog :visible.sync="dialogVisible" width="50%" :show-close="false" @close="handleClose"
    :close-on-click-modal="false">
    
    <div class="flex bg-white radius-30">
      <div class="radius-30 flex-sub wordbook-area "
        :class="{ 'is-area-flipping': isAreaFlipping, 'is-flipped': isFlipped }">
        <div class="word-card" :class="{ 'is-flipped': isFlipped }" :style="cardInlineStyle">
          
          <div class="card-face card-face--front" ref="frontFace">
            <div class="face-header padding-lr-30 flex justify-between align-center solid-bottom h-50 text-main">
              <div class="flex align-center text-18">
                <span class="">{{ wordData?.current_index }}/{{ wordData?.total }}</span>
                <span class="" v-if="wordData?.info?.type == 'e2c'">英译汉</span>
                <span class="" v-if="wordData?.info?.type == 'c2e'">汉译英</span>
                <span class="" v-if="wordData?.info?.type == 'write'">默写</span>
              </div>
              <span class="text-20">{{ title }}</span>
              <i :class="showClose ? 'el-icon-close' : ''" @click="handleClose" style="font-size: 28px;"></i>
            </div>
            
            <div class="card-body text-center">
              <div class="text-80  word-content" style="color: #001a8b" v-if="wordData?.info?.type == 'e2c'">{{
                wordData.vocabulary_info?.name }}</div>
              <div class="text-42 padding-top-10 word-content" style="color: #001a8b"
                v-if="wordData?.info?.type == 'c2e'">{{
                  wordData.vocabulary_info?.definition }}</div>
              <div class="text-16 padding-tb-40 text-000-color" v-if="wordData?.info?.type == 'e2c'">{{
                wordData?.vocabulary_info?.phonetic }}</div>
            </div>
          </div>
          
          <div class="card-face card-face--back">
            <div class="face-header padding-lr-30 flex justify-between align-center solid-bottom h-50 text-main">
              <div class="flex align-center text-18">
                <span class="">{{ progress }}</span>
                <span class="" v-if="wordData?.info?.type == 'e2c'">英译汉</span>
                <span class="" v-if="wordData?.info?.type == 'c2e'">汉译英</span>
                <span class="" v-if="wordData?.info?.type == 'write'">默写</span>
              </div>
              <span class="text-20">{{ title }}</span>
              <span></span>
              
            </div>
            <div class="card-body" style="display: flex;justify-content: center;align-items: center;">
              <div class="text-42 word-content" style="color: #001a8b" v-if="wordData?.info?.type == 'e2c'">{{
                wordData?.vocabulary_info?.definition
              }}</div>
              <div class="text-80 padding-lr-10 word-content" style="color: #001a8b"
                v-if="wordData?.info?.type == 'c2e'">{{
                  wordData?.vocabulary_info?.name }}</div>
              <div class="text-16 padding-tb-40 text-000-color" v-if="wordData?.info?.type == 'c2e'">{{
                wordData?.vocabulary_info?.phonetic }}</div>
            </div>
          </div>
        </div>
      </div>
      
      <div class="flex align-center justify-center flex-direction padding-left-70 padding-right-40">
        <img src="@/assets/icon22.png" class="icon-60" @click="smilingFace" />
        <img src="@/assets/icon21.png" class="icon-60 margin-tb-60" @click="cryingFace" />
        <img src="@/assets/icon20.png" class="w-55 h-50" @click="playAudio" />
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "WordBookDialog",
  data() {
    return {
      isFlipped: false,
      isAreaFlipping: false,
      areaFlipTimer: null,
      cardHeight: null,
      isResetting: false, 
      cryingFaceCycleCount: 0, 
      canSubmit: false, 
      lastCryingFaceState: false, 
      hasClickedCryingFace: false 
    };
  },
  mounted() {
    if (this.dialogVisible) {
      this.$nextTick(this.measureCardHeight);
    }
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    wordData: {
      type: Object,
      default: () => ({})
    },
    progress: {
      type: String,
      default: "0/10"
    },
    title: {
      type: String,
      default: "单词本"
    },
    showClose: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(value) {
        this.$emit("update:visible", value);
      }
    },
    cardInlineStyle() {
      if (this.cardHeight) {
        return {
          minHeight: `${this.cardHeight}px`
        };
      }
      return {};
    }
  },
  watch: {
    dialogVisible(value) {
      if (!value) {
        this.resetFlip();
        
        this.cryingFaceCycleCount = 0;
        this.canSubmit = false;
        this.lastCryingFaceState = false;
        this.hasClickedCryingFace = false;
        return;
      }
      
      this.cryingFaceCycleCount = 0;
      this.canSubmit = false;
      this.lastCryingFaceState = false;
      this.hasClickedCryingFace = false;
      this.$nextTick(this.measureCardHeight);
      
      if (this.wordData?.info?.type === "e2c") {
        this.$nextTick(() => {
          setTimeout(() => {
            this.$emit("play-audio", this.wordData);
          }, 300);
        });
      }
    },
    wordData: {
      handler(newVal, oldVal) {
        if (this.dialogVisible) {
          
          if (newVal && oldVal && newVal !== oldVal) {
            this.cryingFaceCycleCount = 0;
            this.canSubmit = false;
            this.lastCryingFaceState = false;
            this.hasClickedCryingFace = false;
          }

          
          if (newVal && oldVal && newVal !== oldVal && this.isFlipped) {
            
            this.isResetting = true;
            
            
            this.$nextTick(() => {
              this.$nextTick(() => {
                
                requestAnimationFrame(() => {
                  requestAnimationFrame(() => {
                    
                    setTimeout(() => {
                      
                      this.resetFlip();
                      
                      setTimeout(() => {
                        this.isResetting = false;
                        this.$nextTick(this.measureCardHeight);
                        
                        if (newVal?.info?.type === "e2c") {
                          setTimeout(() => {
                            this.$emit("play-audio", newVal);
                          }, 100);
                        }
                      }, 600);
                    }, 30); 
                  });
                });
              });
            });
          } else {
            
            this.$nextTick(this.measureCardHeight);
            
            if (newVal?.info?.type === "e2c") {
              this.$nextTick(() => {
                setTimeout(() => {
                  this.$emit("play-audio", newVal);
                }, 300);
              });
            }
          }
        }
      },
      deep: true
    }
  },
  methods: {
    handleClose() {
      this.$emit("close");
      this.resetFlip();
      
      this.cryingFaceCycleCount = 0;
      this.canSubmit = false;
      this.lastCryingFaceState = false;
      this.hasClickedCryingFace = false;
    },
    playAudio() {
      this.$emit("play-audio", this.wordData);
    },
    smilingFace() {
      
      if (this.isResetting) {
        return;
      }
      
      if (this.hasClickedCryingFace && !this.canSubmit) {
        
        this.handleCryingFaceFlip();
        return;
      }
      
      if (!this.isFlipped) {
        
        this.triggerAreaFlip();
        this.isFlipped = true;
        
        if (this.wordData?.info?.type === "c2e") {
          
          setTimeout(() => {
            this.$emit("play-audio", this.wordData);
          }, 750);
        }
        return;
      }
      
      
      
      this.$emit("smilingFace", this.wordData);
    },
    cryingFace() {
      
      if (this.isResetting) {
        return;
      }
      
      this.hasClickedCryingFace = true;
      
      this.handleCryingFaceFlip();
    },
    
    handleCryingFaceFlip() {
      
      this.triggerAreaFlip();

      
      const previousState = this.isFlipped;
      this.isFlipped = !this.isFlipped;

      
      
      
      if (this.lastCryingFaceState === true && this.isFlipped === false) {
        
        this.cryingFaceCycleCount++;
        this.lastCryingFaceState = false;
        
        if (this.wordData?.info?.type === "e2c") {
          
          setTimeout(() => {
            this.$emit("play-audio", this.wordData);
          }, 750);
        }

        
        if (this.cryingFaceCycleCount >= 4) {
          this.canSubmit = true;
          
          this.$emit("cryingFace", this.wordData);
        }
      } else if (previousState === false && this.isFlipped === true) {
        
        this.lastCryingFaceState = true;
        
        if (this.wordData?.info?.type === "c2e") {
          
          setTimeout(() => {
            this.$emit("play-audio", this.wordData);
          }, 750);
        }
      } else if (previousState === true && this.isFlipped === false) {
        
        this.lastCryingFaceState = false;
        
        if (this.wordData?.info?.type === "e2c") {
          
          setTimeout(() => {
            this.$emit("play-audio", this.wordData);
          }, 750);
        }
      }
    },
    measureCardHeight() {
      const front = this.$refs.frontFace;
      if (!front) return;
      const measured = front.offsetHeight;
      if (measured && measured !== this.cardHeight) {
        this.cardHeight = measured;
      }
    },
    triggerAreaFlip() {
      if (this.areaFlipTimer) {
        clearTimeout(this.areaFlipTimer);
        this.areaFlipTimer = null;
      }
      this.isAreaFlipping = true;
      this.areaFlipTimer = setTimeout(() => {
        this.isAreaFlipping = false;
        this.areaFlipTimer = null;
      }, 600);
    },
    resetFlip() {
      
      if (this.areaFlipTimer) {
        clearTimeout(this.areaFlipTimer);
        this.areaFlipTimer = null;
      }
      this.isAreaFlipping = false;

      
      
      requestAnimationFrame(() => {
        this.isFlipped = false;
      });
    }
  },
  beforeDestroy() {
    if (this.areaFlipTimer) {
      clearTimeout(this.areaFlipTimer);
    }
  }
};
</script>
<style scoped>
.el-dialog__wrapper {
  background-color: rgba(0, 0, 0, 0.7) !important;
}
</style>
<style scoped lang="scss">
::v-deep {

  .el-dialog__header,
  .el-dialog__body {
    padding: 0 !important;
  }

  .el-dialog {
    border-radius: 30px;
    background: transparent;
    box-shadow: none;
  }
}

.solid-bottom {
  border-bottom: 1px solid #2342c9;
}

.word-card {
  position: relative;
  transition: transform 0.6s cubic-bezier(0.4, 0, 0.2, 1);
  transform-style: preserve-3d;
  width: 100%;
  min-height: 360px;
  transform-origin: center center;
  height: 100%;
  will-change: transform;
  
  backface-visibility: hidden;
  
  -webkit-backface-visibility: hidden;
}

.word-card.is-flipped {
  transform: rotateX(180deg);
}

.wordbook-area {
  width: 90% !important;
  transform-origin: center;
  transform-style: preserve-3d;
  perspective: 1000px;
  box-shadow: 0 20px 35px rgba(0, 0, 0, 0.15);
  position: relative;
  backface-visibility: hidden;
  
  -webkit-backface-visibility: hidden;
}

.wordbook-area.is-area-flipping {
  animation: areaFlip 0.75s ease;
}

.wordbook-area.is-flipped {
  
  transform: none;
}

@keyframes areaFlip {
  0% {
    transform: rotateX(0deg);
    box-shadow: 0 20px 35px rgba(0, 0, 0, 0.15);
  }

  30% {
    transform: rotateX(-25deg);
    box-shadow: 0 40px 55px rgba(0, 0, 0, 0.25);
  }

  60% {
    transform: rotateX(15deg);
    box-shadow: 0 25px 45px rgba(0, 0, 0, 0.2);
  }

  100% {
    transform: rotateX(0deg);
    box-shadow: 0 20px 35px rgba(0, 0, 0, 0.15);
  }
}

.card-face {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  backface-visibility: hidden;
  -webkit-backface-visibility: hidden;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: stretch;
  background: #ff9538;
  border-radius: 30px;
  box-sizing: border-box;
  overflow: hidden;
  transform-origin: center center;
  max-height: 500px;
  min-height: 360px;
}

.card-face--front {
  transform: rotateX(0deg);
}

.card-face--back {
  transform: rotateX(180deg);
}

.face-header {
  flex: 0 0 auto;
  background: #ff9538;
}

.card-body {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 20px;
  min-height: 0;

  &::-webkit-scrollbar {
    width: 0;
    background: transparent;
  }

  scrollbar-width: none;
  -ms-overflow-style: none;
}

.word-content {
  word-wrap: break-word;
  word-break: break-word;
  white-space: pre-wrap;
  max-width: 100%;
  overflow-wrap: break-word;
}

@media screen and (min-width: 768px) and (max-width: 1024px) {
  ::v-deep {
    .el-dialog {
      width: 70% !important;
      border-radius: 20px;
    }
  }

  .h-50 {
    height: 40px !important;
  }

  .text-18 {
    font-size: 14px !important;
  }

  .text-20 {
    font-size: 16px !important;
  }

  .text-80 {
    font-size: 60px !important;
  }

  .text-42 {
    font-size: 32px !important;
  }

  .text-26 {
    font-size: 20px !important;
  }

  .padding-lr-30 {
    padding-left: 20px !important;
    padding-right: 20px !important;
  }

  .padding-top-10 {
    padding-top: 8px !important;
  }

  .padding-tb-30 {
    padding-top: 20px !important;
    padding-bottom: 20px !important;
  }

  .padding-left-70 {
    padding-left: 40px !important;
  }

  .padding-right-40 {
    padding-right: 25px !important;
  }

  .icon-60 {
    width: 45px !important;
    height: 45px !important;
  }

  .w-55 {
    width: 40px !important;
  }

  .h-50 {
    height: 40px !important;
  }

  .margin-tb-60 {
    margin-top: 35px !important;
    margin-bottom: 35px !important;
  }

  .wordbook-area {
    border-radius: 20px !important;
  }

  .card-face {
    border-radius: 20px !important;
    max-height: 380px !important;
    min-height: 280px !important;
  }

  .word-card {
    min-height: 280px !important;
  }
}

@media screen and (min-width: 480px) and (max-width: 767px) {
  ::v-deep {
    .el-dialog {
      width: 85% !important;
      border-radius: 15px;
    }
  }

  .h-50 {
    height: 35px !important;
  }

  .text-18 {
    font-size: 12px !important;
  }

  .text-20 {
    font-size: 14px !important;
  }

  .text-80 {
    font-size: 48px !important;
  }

  .text-42 {
    font-size: 26px !important;
  }

  .text-26 {
    font-size: 16px !important;
  }

  .padding-lr-30 {
    padding-left: 15px !important;
    padding-right: 15px !important;
  }

  .padding-top-10 {
    padding-top: 6px !important;
  }

  .padding-tb-30 {
    padding-top: 15px !important;
    padding-bottom: 15px !important;
  }

  .padding-left-70 {
    padding-left: 25px !important;
  }

  .padding-right-40 {
    padding-right: 20px !important;
  }

  .icon-60 {
    width: 38px !important;
    height: 38px !important;
  }

  .w-55 {
    width: 35px !important;
  }

  .h-50 {
    height: 35px !important;
  }

  .margin-tb-60 {
    margin-top: 25px !important;
    margin-bottom: 25px !important;
  }

  .wordbook-area {
    border-radius: 15px !important;
  }

  .card-face {
    border-radius: 15px !important;
    max-height: 320px !important;
    min-height: 220px !important;
  }

  .word-card {
    min-height: 220px !important;
  }
}

@media screen and (min-width: 1440px) {
  ::v-deep {
    .el-dialog {
      width: 55% !important;
    }
  }

  .text-80 {
    font-size: 90px !important;
  }

  .text-42 {
    font-size: 48px !important;
  }

  .text-26 {
    font-size: 30px !important;
  }

  .icon-60 {
    width: 70px !important;
    height: 70px !important;
  }

  .w-55 {
    width: 65px !important;
  }

  .h-50 {
    height: 60px !important;
  }

  .card-face {
    max-height: 550px !important;
  }
}

@media screen and (orientation: portrait) and (max-height: 768px) {
  ::v-deep {
    .el-dialog {
      width: 80% !important;
    }
  }

  .h-50 {
    height: 35px !important;
  }

  .text-80 {
    font-size: 50px !important;
  }

  .text-42 {
    font-size: 24px !important;
  }

  .text-26 {
    font-size: 16px !important;
  }

  .icon-60 {
    width: 35px !important;
    height: 35px !important;
  }

  .card-face {
    max-height: 300px !important;
    min-height: 200px !important;
  }

  .word-card {
    min-height: 200px !important;
  }
}

@media screen and (orientation: landscape) and (max-height: 600px) {
  .h-50 {
    height: 32px !important;
  }

  .text-80 {
    font-size: 42px !important;
  }

  .text-42 {
    font-size: 22px !important;
  }

  .text-26 {
    font-size: 14px !important;
  }

  .icon-60 {
    width: 32px !important;
    height: 32px !important;
  }

  .margin-tb-60 {
    margin-top: 20px !important;
    margin-bottom: 20px !important;
  }

  .card-face {
    max-height: 260px !important;
    min-height: 180px !important;
  }

  .word-card {
    min-height: 180px !important;
  }
}

@media screen and (orientation: landscape) and (min-width: 900px) and (max-width: 1050px) {
  ::v-deep {
    .el-dialog {
      width: 65% !important;
    }
  }

  .h-50 {
    height: 45px !important;
  }

  .text-18 {
    font-size: 15px !important;
  }

  .text-20 {
    font-size: 18px !important;
  }

  .text-80 {
    font-size: 55px !important;
  }

  .text-42 {
    font-size: 30px !important;
  }

  .text-26 {
    font-size: 22px !important;
  }

  .padding-lr-30 {
    padding-left: 25px !important;
    padding-right: 25px !important;
  }

  .padding-top-10 {
    padding-top: 8px !important;
  }

  .padding-tb-30 {
    padding-top: 25px !important;
    padding-bottom: 25px !important;
  }

  .padding-left-70 {
    padding-left: 45px !important;
  }

  .padding-right-40 {
    padding-right: 30px !important;
  }

  .icon-60 {
    width: 50px !important;
    height: 50px !important;
  }

  .w-55 {
    width: 45px !important;
  }

  .h-50 {
    height: 45px !important;
  }

  .margin-tb-60 {
    margin-top: 40px !important;
    margin-bottom: 40px !important;
  }

  .wordbook-area {
    border-radius: 25px !important;
  }

  .card-face {
    border-radius: 25px !important;
    max-height: 380px !important;
    min-height: 300px !important;
  }

  .word-card {
    min-height: 300px !important;
  }
}
</style>
